import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.title',
    defaultMessage: 'Add Task Supplier',
  },
})
